<template>
  <mdb-modal @close="closeModal" size="lg">
    <mdb-modal-header :close="true" class="primary-color text-center text-white">
      <h5>Event in Series</h5>
    </mdb-modal-header>
    <mdb-modal-body class="text-left">
      <p>This event is part of a series. What would you like to do?</p>
      <p>
        <mdb-btn @click="setSeriesChoice('all')" icon="arrows-h" rounded size="sm"/>
        Copy changes to all active events in the series
      </p>

      <p>
        <mdb-btn @click="setSeriesChoice('after')" icon="share-all" rounded size="sm"/>
        Copy changes to all active events <i>after</i> this one.
      </p>
      <p>
        <mdb-btn @click="setSeriesChoice('single')" icon="file-spreadsheet" rounded size="sm"/>
        Only make changes to this one.
      </p>
      <mdb-btn @click="closeModal" color="warning" icon="times-circle" size="sm">Cancel Saving</mdb-btn>
    </mdb-modal-body>
  </mdb-modal>
</template>

<script>
import {mdbBtn, mdbModal, mdbModalBody, mdbModalHeader} from 'mdbvue';

export default {
    name: 'series-modal',
    components: {
      mdbBtn,
      mdbModal,
      mdbModalBody,
      mdbModalHeader
    },
    data() {
      return {}
    },
    methods: {
      closeModal : function() {
        this.$emit("closeModal")
      },
      setSeriesChoice : function(choice) {
        this.$emit("seriesChoice", choice)
      }
    }
  };
</script>
